// The shop cards row slides sideways forever and can be dragged or swiped by hand. The cards are cloned once so the loop
// has no gap; position wraps at half the row width. Hovering pauses the slide; after a drag it resumes by itself.
const SPEED = 38; // pixels per second
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.querySelectorAll('[data-shop-cards-row]').forEach((row) => {
  const viewport = row.parentElement;
  const items = Array.from(row.children);
  if (items.length < 2) return;
  row.append(...items.map((item) => {
    const copy = item.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    copy.setAttribute('tabindex', '-1');
    return copy;
  }));
  row.classList.add('is-marquee');

  let offset = 0;
  let loopWidth = 0;
  let hovering = false;
  let dragging = false;
  let resumeAt = 0;
  let last = performance.now();
  let velocity = 0;

  const measure = () => {
    const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
    loopWidth = row.scrollWidth / 2 + gap / 2;
  };
  const apply = () => {
    if (loopWidth) offset = ((offset % loopWidth) + loopWidth) % loopWidth;
    row.style.transform = `translate3d(${-offset}px, 0, 0)`;
  };
  measure();
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);

  const tick = (now) => {
    const dt = Math.min((now - last) / 1000, 0.1);
    last = now;
    if (!dragging) {
      if (Math.abs(velocity) > 5) {
        offset += velocity * dt;           // glide after a flick
        velocity *= 0.94;
      } else if (!reduceMotion && !hovering && now > resumeAt) {
        offset += SPEED * dt;              // gentle autoplay
      }
      apply();
    }
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);

  viewport.addEventListener('mouseenter', () => { hovering = true; });
  viewport.addEventListener('mouseleave', () => { hovering = false; });

  let startX = 0;
  let startOffset = 0;
  let moved = false;
  let lastX = 0;
  let lastT = 0;
  viewport.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    startX = event.clientX;
    startOffset = offset;
    lastX = event.clientX;
    lastT = performance.now();
    moved = false;
    velocity = 0;
    dragging = true;
  });
  window.addEventListener('pointermove', (event) => {
    if (!dragging) return;
    const dx = event.clientX - startX;
    if (!moved && Math.abs(dx) > 5) {
      moved = true;
      viewport.classList.add('is-dragging');
      try { viewport.setPointerCapture(event.pointerId); } catch (error) { /* capture is optional */ }
    }
    if (!moved) return;
    offset = startOffset - dx;
    const now = performance.now();
    const dt = Math.max(now - lastT, 1) / 1000;
    velocity = -(event.clientX - lastX) / dt;
    lastX = event.clientX;
    lastT = now;
    apply();
  });
  const end = () => {
    if (!dragging) return;
    dragging = false;
    viewport.classList.remove('is-dragging');
    if (!moved) velocity = 0;
    velocity = Math.max(Math.min(velocity, 1800), -1800);
    resumeAt = performance.now() + 1500;
  };
  window.addEventListener('pointerup', end);
  window.addEventListener('pointercancel', end);
  // A drag must not count as a click on a card.
  viewport.addEventListener('click', (event) => {
    if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; }
  }, true);
});
